"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_string_replace_1 = __importDefault(require("react-string-replace"));
var module_components_1 = require("@empiriecom/module-components");
var cuid_1 = __importDefault(require("cuid"));
var dynamicTagStyle_1 = __importDefault(require("./dynamicTagStyle"));
var ModalChild = function (text, modal, elementType) {
    if (elementType === void 0) { elementType = 'span'; }
    var _a = react_1.useState(false), openState = _a[0], setOpenState = _a[1];
    var clickLink = function () {
        setOpenState(true);
    };
    var content = react_string_replace_1.default(text, modal.field_placeholder_id, function () {
        var uuid = cuid_1.default();
        var placeholderText = modal.field_placeholder_text, headline = modal.field_headline, modalContent = modal.field_html_editor;
        return (react_1.default.createElement(react_1.Fragment, { key: "modal-child-" + uuid },
            react_1.default.createElement(dynamicTagStyle_1.default, { tag: elementType, key: "modal-child-button-" + uuid, tabIndex: 0, role: "button", onClick: clickLink }, placeholderText),
            react_1.default.createElement(module_components_1.Modal, { key: "modal-child-modal-" + uuid, headline: headline, onRequestClose: function () { return setOpenState(false); }, open: openState },
                react_1.default.createElement("div", { dangerouslySetInnerHTML: { __html: modalContent } }))));
    });
    return content;
};
exports.default = ModalChild;
//# sourceMappingURL=modal.js.map